export const USER_AVATAR_COLORS = [
  { value: 'LAVENDER', label: 'Lavender', hex: '#9A8EF0' },
  { value: 'SKY', label: 'Sky', hex: '#7EC8F0' },
  { value: 'MINT', label: 'Mint', hex: '#4FB88A' },
  { value: 'AMBER', label: 'Amber', hex: '#FFA000' },
  { value: 'CORAL', label: 'Coral', hex: '#FF7043' },
  { value: 'ROSE', label: 'Rose', hex: '#E0749A' },
] as const

export type UserAvatarColor = (typeof USER_AVATAR_COLORS)[number]['value']

export const DEFAULT_USER_AVATAR_COLOR: UserAvatarColor = 'LAVENDER'

export function userAvatarColorOption(value: UserAvatarColor | string | null | undefined) {
  return USER_AVATAR_COLORS.find((option) => option.value === value) ?? USER_AVATAR_COLORS[0]
}

export function userAvatarColorHex(value: UserAvatarColor | string | null | undefined) {
  return userAvatarColorOption(value).hex
}

export function isUserAvatarColor(value: unknown): value is UserAvatarColor {
  return USER_AVATAR_COLORS.some((option) => option.value === value)
}

export function avatarColorForUserId(userId: string | null | undefined): UserAvatarColor {
  if (!userId) {
    return DEFAULT_USER_AVATAR_COLOR
  }
  let hash = 0
  for (const char of userId) {
    hash = (hash * 31 + char.charCodeAt(0)) % USER_AVATAR_COLORS.length
  }
  return USER_AVATAR_COLORS[hash]?.value ?? DEFAULT_USER_AVATAR_COLOR
}
